import { render, staticRenderFns } from "./product-battle.vue?vue&type=template&id=acb81c34"
import script from "./product-battle.vue?vue&type=script&lang=js"
export * from "./product-battle.vue?vue&type=script&lang=js"
import style0 from "./product-battle.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports